export const donorsListStyle = {
	wrapper: {
		margin: '12px 0',
		display: 'flex',
		gap: '30px',

		flexWrap: 'wrap',
	},

	content: {
		display: 'flex',
		gap: '20px',

		marginBottom: '12px',
	},

	donor: {
		width: '134px',
		minHight: '120px',
		position: 'relative',
	},

	donorImage: {
		maxHeight: '80px',
		height: '100%',
		overflow: 'hidden',
		borderRadius: '8px 8px 0 0',
		'& img': {
			objectFit: 'cover',
			height: '100%',
			width: '100%',
		},
	},

	donorName: {
		height: '60px',
		display: '-webkit-box',
		WebkitLineClamp: 4,
		WebkitBoxOrient: 'vertical',
		overflow: 'hidden',
		fontSize: '14px',
		textAlign: 'center',
		padding: '4px 8px',
		borderRadius: '0px 0px 8px 8px',
		boxShadow: '0px 4px 16px 0px rgba(40, 103, 131, 0.06)',
	},

	dropdown: {
		position: 'absolute',
		right: '4px',
		top: '4px',
		cursor: 'pointer',
	},

	dropdownIcon: {
		'svg path': {
			fill: 'var(--primary-500)',
		},
	},

	dropdownOption: {
		padding: '8px 16px',
		maxWidth: '160px',
		width: '160px',
		textTransform: 'capitalize',
		cursor: 'pointer',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 200px',
			width: '100%',
		},
	},
};
